import { APP_INITIALIZER, NgModule } from '@angular/core'
import { ContentPageMetaResolver, PageMetaService } from '@spartacus/core'
import { PageMetaLinkService, SeoMetaService } from '@spartacus/storefront'
import { MbContentPageMetaResolver } from './mb-content-page-meta-resolver'
import { MbPageMetaService } from './mb-page-meta.service'
import { MbSeoMetaService } from './mb-seo-meta.service'
import { MbPageMetaLinkService } from './mb-page-meta-link.service'
import { PageViewEventBuilder } from './page-view-event-builder'

@NgModule({
  providers: [
    { provide: ContentPageMetaResolver, useExisting: MbContentPageMetaResolver },
    { provide: PageMetaService, useExisting: MbPageMetaService },
    { provide: SeoMetaService, useExisting: MbSeoMetaService },
    { provide: PageMetaLinkService, useExisting: MbPageMetaLinkService },
    {
      provide: APP_INITIALIZER,
      useFactory: (pageViewEventBuilder: PageViewEventBuilder) => () => pageViewEventBuilder.init(),
      deps: [PageViewEventBuilder],
      multi: true
    }
  ]
})

export class PageModule {
}
